// extracted by css-extract-rspack-plugin
export default {"root":"ErrorMessage_root__kHB7q","el":"ErrorMessage_el__FZ6Ro"};